import { gql } from 'graphql-request'

export const GQL_FRAG_IMAGE_FIELDS = gql`
  fragment ImageFields on images_image {
      id
      path
      user_id
      location_id
  }`;